import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as constants from '@redbubble/design-system/react/constants';
import Button from '@redbubble/design-system/react/Button';
import Text from '@redbubble/design-system/react/Text';
import styles from './ErrorWithRetry.css';
import error from './error.svg';
import messages from './messages';

// eslint-disable-next-line react/prefer-stateless-function
export class ErrorWithRetry extends Component {
  render() {
    const { retry, message } = this.props;
    return (
      <div className={styles.errorContainer}>
        <img alt={message} src={error} />
        <Text type="display3" element="h3" className={styles.heading} block>
          {message}
        </Text>
        <Button
          size={constants.SMALL}
          intent={constants.PRIMARY}
          strong
          onClick={() => retry()}
        >
          <FormattedMessage {...messages.RetryButton} />
        </Button>
      </div>
    );
  }
}

ErrorWithRetry.displayName = 'ErrorWithRetry';

ErrorWithRetry.propTypes = {
  retry: PropTypes.func.isRequired,
  message: PropTypes.node
};

export default ErrorWithRetry;
